import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Employee, ServiceGroup, ServiceGroupCategory } from '@quorum/models/xs-resource';
import { ApiService } from '@quorum/api';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Component({
  selector: 'quorum-service-group-selection',
  templateUrl: './service-group-selection.component.html',
  styleUrls: ['./service-group-selection.component.scss'],
})
export class ServiceGroupSelectionComponent implements OnInit {
  filterForm = this.fb.group({
    opCode: [''],
    categoryId: [null],
    showStandardLabourOperations: [false],
  });
  displayedGroups: ServiceGroup[];
  selectedServiceGroup: ServiceGroup = null;
  categories$: Observable<{ rooftopCategories: ServiceGroupCategory[]; sharedCategories: ServiceGroupCategory[] }>;
  modalTitle = 'Add Service Group';

  constructor(
    public dialogRef: MatDialogRef<ServiceGroupSelectionComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      serviceGroups: ServiceGroup[];
      authenticatedEmployee: Employee;
      oemMenu?: boolean;
      selectedMaintenanceItem?: any;
    },
    private apiService: ApiService,
    private fb: FormBuilder
  ) {
    this.displayedGroups = this.dialogData.serviceGroups.filter(
      (sg: ServiceGroup) => sg.rooftopId == this.dialogData.authenticatedEmployee.rooftopId || sg.rooftopId == -1
    );
  }

  ngOnInit() {
    this.modalTitle = this.dialogData.oemMenu
      ? `Select Service Group for ${this.dialogData.selectedMaintenanceItem.title}`
      : 'Add Service Group';

    this.categories$ = this.apiService
      .get(`v/1/fixed-operations/service-group-categories`, {
        params: { rooftopId: `${this.dialogData.authenticatedEmployee.rooftopId},-1` },
      })
      .pipe(
        map((categories) => {
          return {
            rooftopCategories: categories.filter(
              (category: ServiceGroupCategory) => category.rooftopId === this.dialogData.authenticatedEmployee.rooftopId
            ),
            sharedCategories: categories.filter((category: ServiceGroupCategory) => category.rooftopId === -1),
          };
        })
      );

    this.filterForm.valueChanges.pipe(debounceTime(250), distinctUntilChanged()).subscribe((formValue) => {
      if (
        (formValue.opCode && formValue.opCode.length > 0) ||
        formValue.categoryId ||
        formValue.showStandardLabourOperations
      ) {
        this.displayedGroups = this.dialogData.serviceGroups.filter(
          (sg: ServiceGroup) =>
            (sg.rooftopId == this.dialogData.authenticatedEmployee.rooftopId || sg.rooftopId == -1) &&
            (formValue.categoryId ? sg.categoryId == formValue.categoryId : true) &&
            (formValue.opCode && formValue.opCode.length > 0
              ? (sg.workOrderLocationOpCode != null
                  ? sg.workOrderLocationOpCode.toLowerCase().includes(formValue.opCode.toLowerCase())
                  : false) ||
                (sg.name != null && sg.name.toLowerCase().includes(formValue.opCode.toLowerCase()))
              : true) &&
            (formValue.showStandardLabourOperations ? sg.standardOpCodeFlag == true : true)
        );
      } else {
        this.displayedGroups = this.dialogData.serviceGroups.filter(
          (sg: ServiceGroup) => sg.rooftopId == this.dialogData.authenticatedEmployee.rooftopId
        );
      }
    });
  }

  selectServiceGroup(serviceGroup: ServiceGroup) {
    if (this.selectedServiceGroup != null && this.selectedServiceGroup.id == serviceGroup.id) {
      this.selectedServiceGroup = null;
    } else {
      this.selectedServiceGroup = serviceGroup;
    }
  }

  resetServiceGroupFilterForm() {
    this.filterForm.patchValue({
      opCode: '',
      categoryId: null,
      showStandardLabourOperations: false,
    });
  }

  trackByMethod(index: number, el: any): number {
    return el.id;
  }

  cancel() {
    this.dialogRef.close();
  }

  save(selectedServiceGroup: ServiceGroup) {
    this.dialogRef.close({ selectedServiceGroup, addManually: false });
  }

  addCaseManually() {
    this.dialogRef.close({ selectedServiceGroup: null, addManually: true });
  }
}
